import { apiUrl } from './tool'
import axios from 'axios'

const useMock = false

export function searchPatientsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "patient_code": "xAqwDUiQ",
          "phone": "0932007170",
          "name": "黃顗瑄",
          "sex": "9",
          "birthday": ""
        },
        {
          "patient_code": "L5brrDpQ",
          "phone": "0988705260",
          "name": "黃韋翔",
          "sex": "9",
          "birthday": ""
        }
      ]
    })
  }
  const url = apiUrl('patients', 'search')
  return axios.get(url, {params})
}

export function getBlacklistsAPI(params) {
  if (useMock) {
    return Promise.resolve({"total":1,"data":[{"id":"28457","type":"1","clinic_code":"0000000088","doctor_code":null,"kind":"1","value":"0985617117","create_time":"2023-09-11 14:12:07","update_time":null,"birthday":"1987-12-17","patient_name":"\u5f35\u4fca\u9686,ken,\u5f35"}]})
  }
  const url = apiUrl('blacklist')
  return axios.get(url, {params})
}

export function addBlacklistAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('blacklist')
  return axios.post(url, data)
}

export function deleteBlacklistAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('blacklist')
  return axios.delete(url, {params})
}

export function getPatientsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "paginate": {
          "page": "1",
          "limit": "1",
          "page_total": "449",
          "total": "449"
        },
        "data": [
          {
            "patient_code": "xAqwDUiQ",
            "phone": "0932007170",
            "name": "黃顗瑄",
            "sex": "1",
            "birthday": "",
            "file_name_photo": "https://sprofile.line-scdn.net/0h2tTCNhXTbVt5OkVKZnwTJAlqbjFaSzRJUVtwbUs9NzsUWSgEU1Uhb0toNG9DWn4OVAkiPElvM2t1KRo9Z2yRb34KM2xHCSwLUFsjug",
            "line_bot_is_verified": "1",
            "agree": "1"
          }
        ]
      }
    })
  }
  const url = apiUrl('patients')
  return axios.get(url, {params})
}

export function exportPatientsAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('patients', 'download')
  return axios.post(url, data)
}

export function getPatientInfoAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "patient_code": "1f72ilba",
        "phone": "0922099195",
        "name": "蔡友仁",
        "sex": "9",
        "birthday": "570816000",
        "file_name_photo": "",
        "line_bot_is_verified": "1",
        "agree": "1"
      }
    })
  }
  const url = apiUrl('patients', 'info')
  return axios.get(url, {params})
}

export function getPatientNoteAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "note": "2333"
      }
    })
  }
  const url = apiUrl('patients', 'note')
  return axios.get(url, {params})
}

export function updatePatientNoteAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('patients', 'note')
  return axios.put(url, data)
}

export function countPatientsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "total": 441
      }
    })
  }
  const url = apiUrl('patients', 'total')
  return axios.get(url, {params})
}

export function updatePatientAPI(code, data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('patients', code)
  return axios.put(url, data)
}

export function countBlackListsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "total": 441
      }
    })
  }
  const url = apiUrl('blacklist')
  return axios.get(url, {params})
}

export function getPreteethListsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      "paginate":{
        "page":"1",
        "limit":"10",
        "page_total":"1",
        "total":"1"
      },
      "data":[
        {
          "line_bot_id":"U507fe8ac883f9b906b65f0ad606caff9",
          "name":"張俊隆",
          "phone":"0985617117",
          "questionnaire_type":"願意體驗",
          "age_range":"26～35歲",
          "original_photo_path":"https://i.imgur.com/6e8Sa6K.jpg",
          "photo_path":"https://i.imgur.com/6e8Sa6K.jpg",
          "accept_q1":"否",
          "accept_q2":"是",
          "accept_q3":"4",
          "note":"嗨我是俊隆",
          "reject_q1":"",
          "reject_q1_note":"",
          "created_at":"2023-11-16 13:55"
        }
      ]
    })
  }
  const url = apiUrl('preteeth', 'log')
  return axios.get(url, {params})
}

export function exportPreteethListsAPI(params) {
  if (useMock) {
    return Promise.resolve({})
  }
  const url = apiUrl('preteeth', 'download')
  return axios.get(url, {params})
}

export function getPatientChannelBindStatusAPI(patientCode, params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "dentco_channel_bind_status": 1,
        "own_channel_bind_status": 1,
        "own_messenger_channel_bind_status": 0
      }
    })
  }
  const url = apiUrl('patients', patientCode, 'link-status')
  return axios.get(url, {params})
}


export function updateBlacklistNoteAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "success"
      }
    })
  }
  const url = apiUrl('blacklist/note')
  return axios.put(url, data)
}
